<template>
<div class="presentation row">
  <div class="col-3 presentationLogo sm-hide"><img :src="`${publicPath}logo-white.svg`" alt="logo nicolas noel"></div>
      <div class="overlay col-6 col-sm-12"><div class="presentationTexte ">
<div >Je m'appelle Nicolas, je suis designer graphique, illustrateur, développeur, montpelliérain. Créatif sensible, passionné de web, j'invente des solutions uniques pour mettre en valeur des idées, des projets ou des personnes.</div>
<router-link :to="{name:'Apropos'}" >En savoir plus <i class="fas fa-arrow-right"></i></router-link>
</div></div>

  <div class="col-3 sm-hide">    </div>
</div>
</template>

<script>
export default {
  data : function () {
    return{
      publicPath: process.env.BASE_URL,
    }
  }
}
</script>


<style scoped>
.presentation{
  padding: 6.25rem 0;
  font-size: 3rem;
  background-color: #dec8b2;
    font-weight: bold;
    line-height: 4.5rem;
}

.presentation a{
  font-family: 'Poppins', sans-serif;
  font-size: 1.5rem;
  text-transform: uppercase;
  color :#555;
  font-weight: 400;
}

.presentationLogo{

  position: relative;
}

.presentationLogo img{
    padding: 5rem 0;
  position: absolute;
  top:0;
  right:6.25rem;
  height: 100%;
}

@media all and (max-width: 736px) {
.presentationTexte{
  padding: 0 4rem 0 4rem;
}
}
</style>
